// extracted by mini-css-extract-plugin
export default {"inputs-container":"TJogaCzughQ5eIn1ANug","fake-input-container":"KTAOpat7WtXN1ENOpXAT","label":"vbLOmQNgWVBqTnq0DeYq","input":"I7yeHtGgSBPnqaVphUB1"};